import { DoorEnter, Edit, Trash, UserAdd } from 'seagull/icons';
import { eligibilityTooltipProps } from './ContactsDashboardOld.utils';
import { hasPortalAccess, portalAccessDisabledTooltip } from './ContactsDashboardRowOld.utils';
export const showsActionsMenu = (contact)=>!contact.isSample();
export const contactMenuActions = (param)=>{
    let { contact, isEmailUpdateInProgress, texts, rowTexts, clientViewTexts, eligibilityTooltipsTexts, onEdit, onAddToAnotherClient, onDelete, onStartClientView } = param;
    var _eligibilityTooltipProps;
    const isEditDisabledWithoutClient = contact.customerId() == null;
    const editTooltip = isEmailUpdateInProgress ? rowTexts.updateInProgress() : isEditDisabledWithoutClient ? rowTexts.editDisabledNoClient() : undefined;
    return [
        {
            icon: Edit,
            label: texts.edit,
            onClick: ()=>onEdit(contact),
            bi: {
                name: 'contact_edit'
            },
            disabled: isEmailUpdateInProgress || isEditDisabledWithoutClient,
            tooltip: editTooltip
        },
        {
            icon: UserAdd,
            label: rowTexts.addToAnotherClient(),
            onClick: ()=>onAddToAnotherClient(contact),
            bi: {
                name: 'contact_add_to_another_client'
            }
        },
        {
            icon: DoorEnter,
            label: texts.viewClientPortal,
            onClick: ()=>onStartClientView(contact),
            bi: {
                name: 'contact_view_client_portal'
            },
            disabled: !hasPortalAccess(contact) || contact.customerId() == null,
            tooltip: portalAccessDisabledTooltip({
                contact,
                clientViewTexts
            })
        },
        {
            icon: Trash,
            label: texts.delete,
            onClick: ()=>onDelete(contact),
            bi: {
                name: 'actions_delete'
            },
            destructive: true,
            disabled: !contact.canDelete(),
            tooltip: (_eligibilityTooltipProps = eligibilityTooltipProps(contact.deleteEligibility(), eligibilityTooltipsTexts)) === null || _eligibilityTooltipProps === void 0 ? void 0 : _eligibilityTooltipProps.title
        }
    ];
};
